/**
 * 存到本地存储的操作都在这里定义，方便统一处理
 */

// 广西大赛投稿提示
export const $_GUANGXI_COMPETITION_TIPS_KEY = '$_GUANGXI_COMPETITION_TIPS_KEY'

export function setStorage(key: string, data: Object) {
  localStorage.setItem(key, JSON.stringify(data))
}

export function getStorage(key: string): Object {
  const value = localStorage.getItem(key)
  if (!value) return {}

  return JSON.parse(value)
}

export function clearStorage(key: string) {
  localStorage.removeItem(key)
}
